import { mapActions } from "../reducer";

import { MapState } from '../../types';

export const setShowStreetView = (
  value: MapState['showStreetView']
) => mapActions.setShowStreetView(value);
